<template>
	<page>
		<module>
			<view-list ref="view" :work-type="workType" selector :view-config="auth('b_complaint_advice_viewmanage')">
				<template #search>
					<m-search ref="search">
                        <m-search-item label="反馈类型">
                            <c-select name="suggestion_type" :options="suggestionTypcDic" multiple></c-select>
                        </m-search-item>
                        <m-search-item label="处理状态">
                            <c-select name="status" :options="suggestionStateDic" multiple></c-select>
                        </m-search-item>
                        <m-search-item label="反馈内容">
                            <c-input name="feedback_content"></c-input>
                        </m-search-item>
					</m-search>
				</template>

                <!--反馈类型-->
                <template #suggestion_type="{data}">
                    <c-state dict="suggestionTypcDic"  tag :value="data.suggestion_type"></c-state>
                </template>
                <!--反馈人类型-->
                <template #suggestion_user_type="{data}">
                    <c-state dict="userTypeDic"  :value="data.suggestion_user_type"></c-state>
                </template>
                <!--反馈图-->
                <template #feedback_images="{data}">
                    <c-file-list :value="data.feedback_images" size="mini"></c-file-list>
                </template>
                <!--处理状态-->
                <template #status="{data}">
                    <c-state dict="suggestionStateDic"  :value="data.status"></c-state>
                </template>
				<c-table-column
					type="button"
					label="操作"
					width="110"
					button-limit="2"
				>
					<template #default="{data}">
                        <c-table-button v-if="auth('b_complaint_advice_view')" icon="tf-edit" @click="globalDialog('complaintSuggestionDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_complaint_advice_deal') && (data.status == 1)" icon="tf-trash" @click="dealOrder(data)">处理</c-table-button>
                    </template>
				</c-table-column>
			</view-list>
            <!--创建、编辑售后工单信息弹窗-->
            <complaint-suggestion-handle ref="complaintSuggestionHandle" @resolve="updateMethod"></complaint-suggestion-handle>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
    import complaintSuggestionHandle from "@/pages/basic/complaint_suggestion_handle.vue";
	export default {
        components: {complaintSuggestionHandle},
		computed: {
			// 获取dictName选项数据
			...mapState(['suggestionTypcDic','suggestionStateDic'])
		},
		
		data() {
			return {
                workType:10
			}
		},
		
		methods: {
            dealOrder(data){
                this.$refs.complaintSuggestionHandle.open(data);
            },
            updateMethod(){
                //刷新列表
                this.$refs.view.$refs.list.refresh();
            },
		}
	}
</script>

<style lang="stylus" scoped>
</style>